import { STATUS_PENDING, STATUS_SUCCESS, STATUS_FAILURE, STATUS_RESET } from 'Common/constants/commonConstants';
import * as RMConstants from './RMConstants';
import { produce } from "immer";

const assign = Object.assign || require('object.assign');

// Initial state
const initialState = {};

// Reducer
export default function RMReducer(state = initialState, action) {
    switch (action.type) {
        case RMConstants.GET_RM_REPORT_REQUEST: {
            const newState = produce(state, (draft) => {
                if (!draft[action.payload.deviceId]) {
                    draft[action.payload.deviceId] = {};
                }
                draft[action.payload.deviceId].rmReportStatus = STATUS_PENDING;
                draft[action.payload.deviceId].rmReportData = null;
                draft[action.payload.deviceId].rmReportError = null;
            });
            return assign({}, state, newState);
        }

        case RMConstants.GET_RM_REPORT_SUCCESS: {
            const newState = produce(state, (draft) => {
                if (!draft[action.payload.deviceId]) {
                    draft[action.payload.deviceId] = {};
                }
                draft[action.payload.deviceId].rmReportStatus = STATUS_SUCCESS;
                draft[action.payload.deviceId].rmReportData = action.payload.result;
                draft[action.payload.deviceId].rmReportError = null;
            });
            return assign({}, state, newState);
        }

        case RMConstants.GET_RM_REPORT_FAILURE: {
            const newState = produce(state, (draft) => {
                if (!draft[action.payload.deviceId]) {
                    draft[action.payload.deviceId] = {};
                }
                draft[action.payload.deviceId].rmReportStatus = STATUS_FAILURE;
                draft[action.payload.deviceId].rmReportData = null;
                draft[action.payload.deviceId].rmReportError = action.payload.error;
            });
            return assign({}, state, newState);
        }

        default:
            return state;
    }
}
